<template>
   <div class="p-card calendar-home rounded-lg shadow-lg">
      <h1 class="mb-2 h4 font-weight-bold" v-if="title">{{ title }}</h1>
      <b-row :no-gutters="inlineButton || false">
         <!--Autocomplete | Seleção de Cidade-->
         <b-col :cols="inlineButton ? 10 : 12" :lg="col1" class="text-left">
            <div class="p-input sub-title mb-4">{{ subTitle }}</div>
            <span style="display: none">{{ currentPlace }}</span>
            <vue-google-autocomplete
               class="google-autocomplete"
               ref="address"
               id="map"
               classname="form-control"
               placeholder="Digite a cidade..."
               @placechanged="handleAddressData"
               types="(cities)"
               country="br"
               @change="getQueryString"
            >
            </vue-google-autocomplete>
         </b-col>

         <!--Button | Submit do formulário-->
         <b-col :cols="inlineButton ? 2 : 12" :lg="col2">
            <el-button
               @click="submitSearch"
               size="medium"
               type="primary"
               class="d-block w-100 font-weight-bold"
               :class="`${inlineButton ? 'm-0 h-100' : ''}`"
               :style="`${inlineButton ? 'border-radius: 5px' : ''}`"
            >
               <span v-if="inlineButton">
                  <i class="el-icon-search"></i>
               </span>
               <span v-else> Buscar bicicletas </span>
            </el-button>
         </b-col>
      </b-row>
   </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
   name: "SearchBlock",
   components: { VueGoogleAutocomplete },
   props: {
      title: {
         type: String,
         default: "Reserve uma bicicleta e Pedale hoje mesmo:",
      },
      subTitle: {
         type: String,
         default: "Digite a cidade aonde você quer pedalar:",
      },
      dates: {
         type: Array,
      },
      col1: {
         type: Number,
         default: 12,
      },
      col2: {
         type: Number,
         default: 12,
      },
      inlineButton: {
         type: Boolean,
         default: false,
      },
   },
   data() {
      return {
         formSearch: {
            location: {
               value: "",
               label: "",
            },
            dates: [],
            selectedLocale: {},
         },
         address: {
            administrative_area_level_2: "",
            administrative_area_level_1: "",
            country: "",
            locality: "",
            longitude: null,
            latitude: null,
         },
         querySearch: {
            locality: "",
         },
         queryString: "",
      };
   },
   async mounted() {
      // Usado para popular o input de busca na página de buscas.
      const { city } = this.$route.params;
      setTimeout(() => {
         if (city && !this.$refs.address.autocompleteText) {
            const s = city.replaceAll("-", " ");
            this.$refs.address.update(s);
         }
      }, 500);

      // Coloca o focus do cursor no campo de busca
      this.$refs.address.focus();
   },
   methods: {
      /**
       * Armazena o local no store
       * @param {Object} addressData Data of the found location
       */
      async handleAddressData(addressData) {
         this.querySearch = addressData;
         await this.$store.dispatch("place/setSelectedPlace", addressData);
      },

      /**
       * Envia evento click ao clicar no botão de buscar bicicletas
       * */
      async submitSearch() {
         // Obtém o texto do input do componente vue-google-autocomplete
         const query = this.$refs.address.autocompleteText;

         // Usado para verificar se foi clicado em um local ou apenas digitado.
         const userSelectedCity = !query.includes(",");

         // O usuário selecionou uma cidade, então obtém as coordenadas
         if (!userSelectedCity) {
            const { longitude, latitude, locality } = this.currentPlace.place;
            const coordinates = `${longitude},${latitude}`;
            this.locality = locality;
            //const _dates = (dates ? dates.toString() : '');

            // Envia o evento com localidade e as coordenadas
            this.$emit("click", { locality, coordinates });

            this.goSearchPage(locality);
         }

         // O usuário apenas digitou a cidade, mas não selecionou, então obtém a cidade
         if (userSelectedCity) {
            this.locality = query;

            // Usado para atualizar o store place
            const payload = {
               administrative_area_level_2: query,
               administrative_area_level_1: "",
               country: "",
            };
            await this.$store.dispatch("place/setSelectedPlace", payload);

            // Envia o evento click apenas com a localidade
            this.$emit("click", { locality: query });

            this.goSearchPage(query);
         }
      },

      // Vai para a página de busca
      goSearchPage(locality) {
         const slugCity = locality.replaceAll(" ", "-");
         this.$router.push(`/bicicletas/${slugCity}`).catch(() => {});
      },

      // Obtém o texto digitado no campo de busca
      async getQueryString(v) {
         this.queryString = v;
         await this.$store.dispatch("place/setQueryString", v);
      },
   },
   computed: {
      // Obtém o store dos locais (salvo quando o usuário clica em um local após digitar no campo de busca)
      currentPlace() {
         return this.$store.state.place;
      },

      // Obtém o store da busca
      searchQuery() {
         return this.$store.state.search.query;
      },

      mt() {
         if (this.cols === 4) {
            return 2;
         } else if (this.cols === 12) {
            return 3;
         } else {
            return 1;
         }
      },
   },

   watch: {
      $route: {
         handler: function (e) {
            const { place } = this.currentPlace;
            if (place && place.administrative_area_level_2) {
               let query = "";

               // Usado para lidar o preenchimento do campo de busca.
               if (!place.country)
                  query = `${place.administrative_area_level_2}`;

               if (place.country)
                  query = `${place.administrative_area_level_2}, ${place.administrative_area_level_1}, ${place.country}`;

               if (
                  !place.country &&
                  !place.administrative_area_level_2 &&
                  e.params.city
               ) {
                  query = `${e.params.city}`;
               }

               setTimeout(() => {
                  this.$refs.address.update(query);
               }, 100);
            }
         },
         deep: true,
         immediate: true,
      },
   },
};
</script>

<style lang="scss">
.search {
   .google-autocomplete {
      width: 100%;

      @media (max-width: 992px) {
         width: 100%;
         margin-top: 0;
      }
   }
}

.home {
   .google-autocomplete {
   }
}

.google-autocomplete {
   margin-top: 0;
   width: 100%;
   border: 1px solid #d0d0d0;
   border-radius: 5px;
   padding: 10px 15px;

   @media (max-width: 992px) {
      width: 94%;
   }
}

.pac-container {
   border-radius: 8px !important;
   padding-left: 13px;

   .pac-item {
      padding: 5px 3px !important;
   }

   .pac-item-query {
      font-size: 15px !important;
   }
}
</style>
